import { SET_RAISE_HAND,SET_LAYOUT_TYPE } from "./videoRoomAction";

const initialState = {
  raiseHand: false,
  layoutType:'grid'
};

const videoRoomReducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_RAISE_HAND:
      return {
        ...state,
        raiseHand: action.payload,
      };
      case SET_LAYOUT_TYPE:
        return {
          ...state,
          layoutType: action.payload,
        };
    default:
      return state;
  }
};
export default videoRoomReducer;